var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import MarkdownViewer from "../../Markdown";
import React, { Component } from 'react';
import { TabContent, TabLink, Tabs } from 'react-tabs-redux';
import { Translate } from "../../I18N";








export class MarkDown extends Component {
  render() {
    const { rows = 6, value = '', onChange, showPreview = true } = this.props;
    return (/*#__PURE__*/
      _jsx("div", { className: "markdownEditor" }, void 0, /*#__PURE__*/
      _jsx(Tabs, { renderActiveTabContentOnly: true }, void 0, /*#__PURE__*/
      _jsx("div", { className: "tab-nav" }, void 0, /*#__PURE__*/
      _jsx(TabLink, { to: "edit", default: true, component: "div" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Edit")
      ),
      showPreview && /*#__PURE__*/
      _jsx(TabLink, { to: "preview", component: "div" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Preview")
      ), /*#__PURE__*/

      _jsx("a", {
        className: "tab-link tab-link--help",
        href: "https://guides.github.com/features/mastering-markdown/",
        target: "_blank",
        rel: "noopener noreferrer" }, void 0, /*#__PURE__*/

      _jsx(Translate, {}, void 0, "help")
      )
      ), /*#__PURE__*/
      _jsx(TabContent, { for: "edit" }, void 0, /*#__PURE__*/
      _jsx("textarea", { className: "form-control", rows: rows, onChange: onChange, value: value })
      ),
      showPreview && /*#__PURE__*/
      _jsx(TabContent, { for: "preview", className: "markdownViewer" }, void 0, /*#__PURE__*/
      _jsx(MarkdownViewer, { html: this.props.htmlOnViewer, markdown: value })
      )

      )
      ));

  }
}